import { render, staticRenderFns } from "./GridCard.vue?vue&type=template&id=2a3e6a50"
import script from "./GridCard.vue?vue&type=script&lang=ts"
export * from "./GridCard.vue?vue&type=script&lang=ts"
import style0 from "./GridCard.vue?vue&type=style&index=0&id=2a3e6a50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports